"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FPickupPointsService = void 0;
const domain_1 = require("../../../domain");
const __1 = require("..");
class FPickupPointsService {
    constructor(apolloClient) {
        this.apolloClient = apolloClient;
    }
    getPickupPoints(variables) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const { data, loading } = yield this.apolloClient.query({
                    query: __1.GET_PICKUP_POINTS,
                    variables,
                    fetchPolicy: "no-cache",
                });
                return Promise.resolve({ pickupPoints: data.pickUpPointsWithSelected, loading });
            }
            catch (error) {
                return Promise.reject(new domain_1.PickupPointsErrors.getPickupPointsError('error getting pickupPoints', error));
            }
        });
    }
    getUserLastUsedPickupPoint(variables) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const { data, loading } = yield this.apolloClient.query({
                    query: __1.GET_LATEST_PICKUP_POINT,
                    variables,
                    fetchPolicy: "no-cache",
                });
                return Promise.resolve({ pickupPoint: data === null || data === void 0 ? void 0 : data.userLastUsedPickupPoint, loading });
            }
            catch (error) {
                return Promise.reject(new domain_1.PickupPointsErrors.getUserLastUsedPickupPointError('error getting last used pickupPoint', error));
            }
        });
    }
}
exports.FPickupPointsService = FPickupPointsService;
